import { useNavigate, useLocation } from "react-router-dom";

export default function HeroSection() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBooking = () => {
    if (window.innerWidth < 768 && location.pathname === "/") {
      const el = document.getElementById("contact");
      if (el) { el.scrollIntoView({ behavior: "smooth" }); return; }
    }
    navigate("/contact");
  };

  const scrollToAbout = () => {
    const el = document.getElementById("about");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center"
    >
      {/* Background Image */}
      <div className="absolute inset-0 overflow-hidden">
        {/* スマホ・デスクトップ共通画像 */}
        <img
          src="https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/96346a7f-f33c-4c7d-b0bb-2b7638f4fa80_ChatGPT-Image-2026413-22_24_17.png?v=f235c1c5b24d8ba79c11a7aa4ca75936"
          alt="Mugi Cha Production"
          className="w-full h-full object-cover"
          style={{ objectPosition: '20% center', transform: 'scale(1.15)', transformOrigin: '20% center' }}
        />
        {/* オーバーレイ */}
        <div className="absolute inset-0 bg-gradient-to-b from-white/55 via-white/35 to-white/60"></div>
      </div>

      {/* Content */}
      {/* スマホ：右寄せで人物と重ならないように / デスクトップ：中央揃え */}
      <div className="relative z-10 w-full px-6 flex flex-col items-end md:items-center text-right md:text-center">

        {/* Private Session ラベル */}
        <p className="text-sm md:text-base tracking-[0.35em] text-amber-700 uppercase mb-4 md:mb-6">
          Private Session
        </p>

        {/* メインタイトル */}
        <h1
          className="font-en text-3xl md:text-7xl font-light text-stone-800 tracking-widest mb-3 md:mb-4 leading-snug"
        >
          Mugi Cha<br className="block md:hidden" /> Production
        </h1>

        {/* サブタイトル英語 */}
        <p
          className="font-en text-sm md:text-2xl font-light text-stone-600 tracking-wider md:tracking-widest mb-3 italic"
        >
          Only for You –<br className="block md:hidden" /> Private Release Session
        </p>

        <div className="w-12 md:w-16 h-px bg-amber-400 md:mx-auto my-4 md:my-6"></div>

        {/* 日本語タイトル */}
        <p
          className="text-lg md:text-2xl font-light text-stone-500 tracking-[0.25em] md:tracking-[0.35em] mb-2"
        >
          むぎ茶プロダクション
        </p>

        {/* キャッチコピー */}
        <p
          className="text-sm md:text-lg text-stone-400 tracking-[0.15em] md:tracking-[0.25em] font-light -mt-1 md:mt-0"
          style={{
            textShadow: '0 1px 8px rgba(255,255,255,0.95), 0 0px 16px rgba(255,255,255,0.85), 0 2px 4px rgba(255,255,255,0.9)',
          }}
        >
          あなたのためだけの<br className="block md:hidden" />解放できる時間
        </p>

        {/* CTA ボタン */}
        <div className="mt-8 md:mt-12 flex justify-end md:justify-center">
          <button
            onClick={handleBooking}
            className="group relative px-7 md:px-12 py-3 md:py-4 bg-stone-800 text-white text-sm md:text-base tracking-[0.2em] cursor-pointer whitespace-nowrap transition-colors duration-300"
          >
            <span className="relative z-10 flex items-center gap-2 md:gap-3">
              <i className="ri-calendar-line text-xs md:text-sm"></i>
              ご予約はこちら
              <i className="ri-arrow-right-line text-xs md:text-sm transition-transform duration-300 group-hover:translate-x-1"></i>
            </span>
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-amber-400 group-hover:w-full transition-all duration-500 ease-in-out"></span>
          </button>
        </div>
      </div>

      {/* スマホ専用：スクロール誘導矢印 */}
      <button
        onClick={scrollToAbout}
        className="block md:hidden absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-1 cursor-pointer group"
        aria-label="下にスクロール"
      >
        <span
          className="font-en text-[10px] tracking-[0.3em] text-stone-400 group-hover:text-stone-600 transition-colors duration-300"
        >
          scroll
        </span>
        <div className="flex flex-col items-center gap-0.5" style={{ animation: "scrollBounce 1.8s ease-in-out infinite" }}>
          <i className="ri-arrow-down-s-line text-stone-400 text-xl group-hover:text-amber-600 transition-colors duration-300" style={{ opacity: 1 }}></i>
          <i className="ri-arrow-down-s-line text-stone-300 text-xl group-hover:text-amber-400 transition-colors duration-300" style={{ opacity: 0.5 }}></i>
        </div>
      </button>

      {/* バウンスアニメーション定義 */}
      <style>{`
        @keyframes scrollBounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(6px); }
        }
      `}</style>
    </section>
  );
}
